import React, { useState } from "react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card"; 
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "./DataTable";
import { useSystemTheme } from "context/SystemThemeContext";

const TotalUsers = () => {
  const { mode } = useSystemTheme();
  const isDarkMode = mode === "dark";
  const [hasIterationCount, setHasIterationCount] = useState(false);

  const baseColumns = [
    { Header: "Question", accessor: "content", align: "left" },
    { Header: "IP Address", accessor: "ip_address", align: "left" },
    { Header: "Location", accessor: "country_flag", align: "left" },
    { Header: "Date & Time", accessor: "created_at", align: "left" },
    { Header: "Likes/Dislikes", accessor: "likes_dislikes", align: "left" },
    { Header: "Actions", accessor: "answer", align: "left" },
  ];

  const columns = hasIterationCount
    ? [
        ...baseColumns.slice(0, 4),
        { Header: "No of Searches", accessor: "iteration_merge_search_count", align: "left" },
        ...baseColumns.slice(4),
      ]
    : baseColumns;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ width: "100%", marginTop: "0px" }}>
        <Card
          sx={{
            backgroundColor: isDarkMode ? "#000000" : "#ffffff",
            transition: "background-color 0.3s ease",
          }}
        >
          <SoftBox p={3} lineHeight={1.2}>
            <div style={{ width: "100%" }}>
              <DataTable
                table={{ columns, rows: [] }}
                entriesPerPage={{ defaultValue: 8, entries: [5, 10, 15] }}
                canSearch
                date
                csv
                showTotalEntries
                onIterationCountDetected={setHasIterationCount}
              />
            </div>
          </SoftBox>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default TotalUsers;